import moment from 'moment'

moment.locale('pt')

export default (date, formatFrom = 'YYYY-MM-DD', formatTo = 'dddd') => {
  return moment(date, formatFrom).format(formatTo)
}



// WEBPACK FOOTER //
// ./src/plugins/day-of-week.js